module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Nut Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 12 | Prep Time: 10 minutes | Cook Time: 45–55 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Applesauce is such an easy alternative to use when you’re looking to lighten up a recipe. It’s often used to replace oil in baking. It’s just as yummy but cuts back on fat and calories (with no added sugar)! And as a bonus, the almond flour makes this recipe gluten-free!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 ripe bananas")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 large eggs, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup applesauce")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 tablespoons vegetable or canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2¼ cups almond flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup chopped pecans")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Preheat the oven to 350°F. Coat a 9 × 5-inch loaf pan with cooking spray. Line the bottom of the pan with parchment paper and coat with cooking spray again.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. Mash the bananas and place into a 2-cup liquid measuring cup.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Add the eggs, applesauce, and vegetable oil to the bananas. Stir to blend. Add enough water to fill the measuring cup of wet ingredients to 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. In a medium bowl, combine the flour, baking powder, cinnamon, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Add the wet ingredients to the dry ingredients and mix just until combined. Do not overmix.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. Stir in the pecans and vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. Pour the batter into the prepared loaf pan and bake for 45 to 55 minutes until golden.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. Place the bread, in the pan, on a wire rack to cool for 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("9. Run a knife or flat metal spatula around the pan. Carefully turn the bread out of the pan onto the rack to cool further. Slice and serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0905d36c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect1.vue
// module id = 87
// module chunks = 0